import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Reset CSS */
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body {
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    background-color: #121212;
    color: #E0E0E0;
    line-height: 1.5;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul, ol {
    list-style: none;
  }

  button, input, textarea, select {
    font-family: inherit;
    font-size: inherit;
    outline: none;
  }

  /* Styles spécifiques pour les boutons */
  button {
    cursor: pointer;
    border: none;
    background: none;
  }

  img {
    max-width: 100%;
    display: block;
  }

  /* Amélioration pour les inputs en mode sombre */
  input, textarea, select {
    background-color: #1E1E1E;
    border: 1px solid #333333;
    color: #E0E0E0;
    padding: 0.75rem 1rem;
    border-radius: 4px;
  }

  input::placeholder, textarea::placeholder {
    color: #777777;
  }

  input:focus, textarea:focus, select:focus {
    border-color: #FFD700;
    box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);
  }

  /* Animation globale pour les transitions */
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    opacity: 1;
    transition: opacity 300ms;
  }
  .fade-exit {
    opacity: 1;
  }
  .fade-exit-active {
    opacity: 0;
    transition: opacity 300ms;
  }

  /* Styles additionnels pour le mode sombre */
  .card, .box, .panel {
    background-color: #1E1E1E;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
  }

  hr {
    border: none;
    border-top: 1px solid #333333;
    margin: 1.5rem 0;
  }

  code, pre {
    font-family: 'Roboto Mono', monospace;
    background-color: #2A2A2A;
    color: #E0E0E0;
    border-radius: 4px;
  }

  /* Ajustements pour le scrollbar */
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #1E1E1E;
  }

  ::-webkit-scrollbar-thumb {
    background: #333333;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #444444;
  }

  :root {
    --button-text: black;
  }
`;

export default GlobalStyles; 